// extracted by mini-css-extract-plugin
export default {"moldura":"Legado_moldura__EHzdX"};